<mb-stream-player
  *ngIf="
    activeStream.video && !activeStream.playerConfig?.externalPlayer && !activeStream.playerConfig?.showErrorScreen
  "
  [autoplay]="true"
  [media]="activeStream.video"
  [stream]="activeStream"
  [transcript]="transcript"
  [showBackButton]="true"
  [allowPictureInPicture]="allowPictureInPicture"
  [isEmbedPlayer]="isEmbedPlayer"
  (backButton)="OnClosePlayer()"
  (streamStopped)="OnStopStream()"
  (shareStream)="onShareStream()"
  (openMedia)="onOpenMedia($event)"
  (streamErrorData)="setStreamPlayerConfig($event)"
></mb-stream-player>
<mb-stream-player-error
  *ngIf="activeStream.playerConfig?.showErrorScreen"
  [streamId]="activeStream.id"
  [streamStatus]="activeStream.status"
  [errorText]="activeStream.playerConfig?.errorText"
  (closeStreamPlayer)="OnClosePlayer()"
  (streamErrorData)="setStreamPlayerConfig($event)"
></mb-stream-player-error>
